
        import 'Speciality.929bdc2.css-module'
        export default {"Speciality":"Speciality_Speciality_929bdc2","small":"small_Speciality_929bdc2"}
    